@if (open()) {
<div class="modal-backdrop fade show"></div>
<div class="modal fade show detail-modal" tabindex="-1" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content profile-modal-content">
      <div class="modal-header">
        <h2 class="modal-title">{{ 'components.topbar.profile-modal.title' | translate }}</h2>
        <button class="btn-close" type="button" (click)="close()"></button>
      </div>

      <div class="modal-body profile-modal-body">
        @if (loading()) {
        <div class="profile-modal-loading">
          <app-spinner size="m" type="ripple" />
        </div>
        } @else if (profile(); as profile) {
        <section class="profile-modal-section">
          <div class="profile-fields-grid">
            <div class="profile-field">
              <label class="profile-field__label">{{ 'pages.users.fields.username' | translate }}</label>
              <input class="form-control" readonly type="text" [value]="profile.username" />
            </div>
            <div class="profile-field">
              <label class="profile-field__label">{{ 'pages.users.fields.contact' | translate }}</label>
              <input class="form-control" readonly type="text"
                [value]="('components.topbar.profile-modal.boolean.' + (profile.contact ? 'yes' : 'no')) | translate" />
            </div>
            <div class="profile-field">
              <label class="profile-field__label">{{ 'pages.users.fields.first-name' | translate }}</label>
              <input class="form-control" readonly type="text" [value]="profile['first-name']" />
            </div>
            <div class="profile-field">
              <label class="profile-field__label">{{ 'pages.users.fields.last-name' | translate }}</label>
              <input class="form-control" readonly type="text" [value]="profile['last-name']" />
            </div>
            <div class="profile-field">
              <label class="profile-field__label">{{ 'pages.users.fields.phone' | translate }}</label>
              <input class="form-control" readonly type="text" [value]="profile.phone" />
            </div>
            <div class="profile-field">
              <label class="profile-field__label">{{ 'pages.users.fields.avatar' | translate }}</label>
              <input class="form-control" readonly type="text" [value]="profile['avatar-url'] || ''" />
            </div>
          </div>
        </section>

        <section class="profile-modal-section">
          <div class="profile-section-header">
            <h3 class="profile-section-title">{{ 'components.topbar.profile-modal.sections.account' | translate }}</h3>
          </div>
          <div class="profile-application-card">
            <div class="profile-account__logo">
              @if (profile.account?.['logo-url']) {
              <img [alt]="profile.account?.name || ''" [src]="profile.account?.['logo-url']" loading="lazy" />
              } @else {
              <div class="profile-logo-fallback">
                <i class="fa-regular fa-image" aria-hidden="true"></i>
              </div>
              }
            </div>
            <div class="profile-application-card__content">
              <span class="profile-account__name">{{ profile.account?.name || '-' }}</span>
            </div>
          </div>
        </section>

        <section class="profile-modal-section">
          <div class="profile-section-header">
            <h3 class="profile-section-title">{{ 'components.topbar.profile-modal.sections.applications' | translate }}</h3>
          </div>

          @if (profileApplications().length === 0) {
          <p class="profile-empty">{{ 'components.topbar.profile-modal.empty.applications' | translate }}</p>
          } @else {
          <div class="profile-applications-list">
            @for (item of profileApplications(); track item.application.id ?? item.application.code) {
            <article class="profile-application-card">
              <div class="profile-application-card__logo">
                @if (item.application['logo-url']) {
                <img [alt]="item.application.name" [src]="item.application['logo-url']" loading="lazy" />
                } @else {
                <div class="profile-logo-fallback">
                  <i class="fa-regular fa-image" aria-hidden="true"></i>
                </div>
                }
              </div>
              <div class="profile-application-card__content">
                <div class="profile-application-card__heading">
                  <span class="profile-application-card__name">{{ item.application.name }}</span>
                  <a class="profile-application-card__link" [href]="item.application['site-url']" rel="noreferrer"
                    target="_blank">
                    <i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
                    {{ 'components.topbar.profile-modal.actions.open-site' | translate }}
                  </a>
                </div>
                <div class="profile-application-card__meta">
                  <span class="profile-application-card__label">
                    {{ 'components.topbar.profile-modal.fields.associated-profile' | translate }}:
                  </span>
                  <span>{{ item.profileName || '-' }}</span>
                </div>
              </div>
            </article>
            }
          </div>
          }
        </section>
        }
      </div>

      <div class="modal-footer">
        <button class="btn btn-light" type="button" (click)="close()">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          {{ 'pages.users.actions.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}
